'use client';

import type { ComponentPropsWithoutRef, Ref } from 'react';

import classnames from 'classnames';

import { Badge } from '../../badge';
import type { BaseComponentProps } from '../../base-component.types';
import { DifficultyLevel } from '../Question.types';

import styles from './DifficultyBadge.module.scss';

export type DifficultyBadgeType = ComponentPropsWithoutRef<'div'> &
  BaseComponentProps & {
    // Accepts the enum's values as well as its members, so callers holding a
    // plain 'easy' | 'medium' | 'hard' off the wire need no cast.
    difficulty: `${DifficultyLevel}`;
  };

export function DifficultyBadge({
  style,
  className,
  difficulty,
  testId = 'ui-difficulty-badge',
  ref,
  ...rest
}: DifficultyBadgeType & { ref?: Ref<HTMLDivElement> }) {
  return (
    <Badge
      ref={ref}
      style={style}
      className={classnames(styles['difficulty'], className)}
      bg={
        difficulty === 'easy'
          ? 'success'
          : difficulty === 'medium'
            ? 'warning'
            : 'danger'
      }
      data-testid={testId}
      {...rest}
    >
      {difficulty === 'easy'
        ? 'Fácil'
        : difficulty === 'medium'
          ? 'Media'
          : 'Difícil'}
    </Badge>
  );
}
